import React, { useState } from 'react';
import { X, Megaphone, ArrowRight } from 'lucide-react';

const STYLES = {
  info: 'bg-[#1565C0] text-white',
  success: 'bg-[#2E7D32] text-white',
  warning: 'bg-amber-400 text-[#050505]',
  dark: 'bg-[#050505] text-white',
};

/**
 * Promo / announcement strip shown under the header on the homepage.
 * Content comes from the admin CMS; each banner can be dismissed per session.
 */
export default function PromoBannerStrip({ banners = [] }) {
  const [dismissed, setDismissed] = useState([]);
  const visible = banners.filter((b) => !dismissed.includes(b.id));
  if (visible.length === 0) return null;

  return (
    <div data-testid="promo-banner-strip">
      {visible.map((b) => (
        <div key={b.id} className={`${STYLES[b.style] || STYLES.info} w-full`} data-testid={`promo-banner-${b.id}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-2.5 flex items-center gap-3">
            <Megaphone className="w-4 h-4 flex-shrink-0 opacity-90" />
            <p className="flex-1 min-w-0 text-sm font-semibold leading-snug">
              {b.message}
              {b.link_url && b.link_text && (
                <a
                  href={b.link_url}
                  className="ml-2 inline-flex items-center gap-1 underline underline-offset-2 font-bold hover:opacity-80 transition-opacity"
                  data-testid={`promo-banner-link-${b.id}`}
                >
                  {b.link_text} <ArrowRight className="w-3.5 h-3.5" />
                </a>
              )}
            </p>
            <button
              type="button"
              onClick={() => setDismissed((d) => [...d, b.id])}
              aria-label="Dismiss announcement"
              className="flex-shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors"
              data-testid={`promo-banner-dismiss-${b.id}`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
